import { render, staticRenderFns } from "./app-text-ellipsis.vue?vue&type=template&id=df7f8b50&"
import script from "./app-text-ellipsis.vue?vue&type=script&lang=js&"
export * from "./app-text-ellipsis.vue?vue&type=script&lang=js&"
import style0 from "./app-text-ellipsis.vue?vue&type=style&index=0&id=df7f8b50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports